import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import CenterCenter from '@/components/layout/CenterCenter.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import store from '@/store';
import { Options, Vue } from 'vue-class-component';
import { AUTH_REQUEST, AuthParams } from '@/store/actions/auth';
import { router } from "@/router";
var LoginView = /*#__PURE__*/function (_Vue) {
  function LoginView() {
    var _this;
    _classCallCheck(this, LoginView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LoginView, [].concat(args));
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "loginForm", {
      username: '',
      password: ''
    });
    return _this;
  }
  _inherits(LoginView, _Vue);
  return _createClass(LoginView, [{
    key: "updateUserName",
    value: function updateUserName(value) {
      this.loginForm.username = value === null || value === void 0 ? void 0 : value.trim();
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(value) {
      this.loginForm.password = value;
    }
  }, {
    key: "login",
    value: function login() {
      var _this2 = this;
      if (this.requiredFieldIsMissing()) {
        return;
      }
      this.errorMsg = '';
      this.loading = true;
      var params = new AuthParams(this.loginForm.username, this.loginForm.password);
      store.dispatch(AUTH_REQUEST, params).then(function () {
        router.push('/');
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
        // TODO catch error
      });
    }
  }, {
    key: "requiredFieldIsMissing",
    value: function requiredFieldIsMissing() {
      return !this.loginForm.username || !this.loginForm.password;
    }
  }]);
}(Vue);
LoginView = __decorate([Options({
  components: {
    MainTitle: MainTitle,
    CenterCenter: CenterCenter
  }
})], LoginView);
export default LoginView;